export const image = "https://appimages.pacificweb.com.ph/vehicles/";
export const images = "https://appimages.pacificweb.com.ph/";
